import {Directive, ElementRef, HostListener, Input, OnInit, Renderer2} from '@angular/core';
import {NgForm} from '@angular/forms';

@Directive({
  selector: '[appValidate]',
  standalone: false
})
export class ValidateDirective implements OnInit {
  @Input('appValidate') form!: NgForm;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  ngOnInit(): void {
    // Ensure the button has a relative position if not already set
    const position = window.getComputedStyle(this.el.nativeElement).position;
    if (position !== 'absolute' && position !== 'fixed' && position !== 'sticky') {
      this.renderer.setStyle(this.el.nativeElement, 'position', 'relative');
    }

    // Add a span element to overlay the button
    const overlay = this.renderer.createElement('span');
    this.renderer.setStyle(overlay, 'position', 'absolute');
    this.renderer.setStyle(overlay, 'top', '0');
    this.renderer.setStyle(overlay, 'left', '0');
    this.renderer.setStyle(overlay, 'width', '100%');
    this.renderer.setStyle(overlay, 'height', '100%');
    // this.renderer.setStyle(overlay, 'z-index', '1');
    this.renderer.setStyle(overlay, 'cursor', 'pointer');
    this.renderer.appendChild(this.el.nativeElement, overlay);

    // Ensure the overlay does not block the button's content
    // this.renderer.setStyle(this.el.nativeElement, 'z-index', '0');
  }

  @HostListener('pointerup', ['$event'])
  onClick(event: Event): void {
    if (this.form?.invalid) {
      console.log('appValidate - form revalidation triggered');
      Object.keys(this.form.controls).forEach((key) => {
        this.form.controls[key].markAsTouched();
      });
    }
  }
}
